module.exports = __webpack_public_path__ + "static/media/bg_price_plan_from_45_to_49.25d2b271.webp";